import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { polkadotIcon } from '@polkadot/ui-shared';
function renderCircle(_ref, key) {
  let {
    cx,
    cy,
    fill,
    r
  } = _ref;
  return _jsx("circle", {
    cx: cx,
    cy: cy,
    fill: fill,
    r: r
  }, key);
}
function Identicon(_ref2) {
  let {
    address,
    className = '',
    isAlternative = false,
    size,
    style = {}
  } = _ref2;
  const circles = useMemo(() => polkadotIcon(address, {
    isAlternative
  }), [address, isAlternative]);
  return _jsx("svg", {
    className: className,
    height: size,
    id: address,
    name: address,
    style: style,
    viewBox: '0 0 64 64',
    width: size,
    children: circles.map(renderCircle)
  });
}
export const Polkadot = React.memo(Identicon);